'use strict';

angular.module('randomization')
    .component('randomizationBlock', {
        templateUrl: 'modules/randomization/components/block/content.html',
        controller: 'RandomizationBlockController',
        bindings: {
            blockId: '<',
        },
    });
